import { render, staticRenderFns } from "./intereses.vue?vue&type=template&id=068a1ade"
import script from "./intereses.vue?vue&type=script&lang=js"
export * from "./intereses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports